module.exports = __webpack_public_path__ + "img/22.6e7916fb.jpg";